// extracted by mini-css-extract-plugin
export default {"categoriesWrapper":"CategoriesFilter_categoriesWrapper--hOr"};